import React from 'react'
import Navbar from '../components/Navbar'

import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { submit_feedback } from '../redux/actions/AuthAction';

export default function CustomerService() {
    const [inputValue, setInputValue] = useState('');
    const user = localStorage.getItem('userRepeatMe')
    const email = JSON.parse(user).email
    const dispatch = useDispatch()

    const isDarkTheme = useSelector(state => state.theme?.theme)

    const handleChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        // Perform some action with the input value
        console.log('Input value:', inputValue);
        dispatch(submit_feedback({ feedback: inputValue, email }));
    };

    return (
        <>
            <Navbar />
            <div className="flex flex-col items-center justify-center mx-auto mt-8  text-center">
                <form className="flex flex-col items-start max-w-[350px]" onSubmit={handleSubmit}>
                    <textarea
                        className={`border-2 h-[400px] border-gray-300 rounded-md px-4 py-6 mb-4 w-[340px] outline-none ${isDarkTheme ? 'border-gray-500' : 'border-gray-300'}`}
                        rows="5"
                        type="text"
                        value={inputValue}
                        onChange={handleChange}
                        placeholder="Enter your question"
                        style={{ backgroundColor: isDarkTheme ? 'black' : 'white', color: isDarkTheme ? 'white' : 'black' }}
                    />
                    <button className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-2 px-4 rounded" type="submit">
                        Submit
                    </button>
                </form>
            </div>
        </>
    );
}
